import React, { useState } from "react";
import { Box, Typography, TextField, IconButton, Tooltip } from "@mui/material";
import { Edit, Save, Close, Delete } from "@mui/icons-material";
import axios from "axios";

import { logDev } from "../utils/logger.js";

const FicheContact = ({ contact, onDelete, isAdmin, onUpdate, sondageVerrouille }) => {
  logDev("[FicheContact] sondageVerrouille =", sondageVerrouille);
  
  const isLocked = sondageVerrouille;
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({
    nom: contact.nom,
    telephone: contact.telephone || "",
    mail: contact.mail || ""
  });

  const handleSave = async () => {
    try {
      logDev("[FicheContact] tentative sauvegarde", { id: contact._id, editData });

      const res = await axios.put(
        `${process.env.REACT_APP_API}/contacts/${contact._id}`,
        editData
      );

      logDev("[FicheContact] réponse API", res.data);

      if (typeof onUpdate === "function") {
        onUpdate(res.data);
      }

      setIsEditing(false);
    } catch (err) {
      logDev("❌ Erreur mise à jour contact", { message: err.message, stack: err.stack });
      alert("❌ Échec de la mise à jour");
    }
  };

  return (
    <Box 
    sx={{ 
      p: 2,
      border: "1px solid #ccc",
      borderRadius: 2,
      backgroundColor: "#fffdf2", // ✅ fond blanc
      boxShadow: 2,            // ✅ ombre légère
      width: { xs: 220, sm: 200, md: 240 }, // ✅ responsive
      maxWidth: "100%",
      height: "auto", // ✅ pas de hauteur forcée
      boxSizing: "border-box"
    }}>
      {isEditing && !sondageVerrouille ?  (
        <>
          <TextField
            label="Nom"
            value={editData.nom}
            onChange={(e) => setEditData({ ...editData, nom: e.target.value })}
            fullWidth
            sx={{ mb: 1 }}
            InputProps={{
              sx: { fontSize: { xs: "0.85rem", md: "0.65rem" } }
            }}
            InputLabelProps={{
              sx: { fontSize: { xs: "0.75rem", md: "0.6rem" } }
            }}
          />
          <TextField
            label="Téléphone"
            value={editData.telephone}
            onChange={(e) => setEditData({ ...editData, telephone: e.target.value })}
            fullWidth
            sx={{ mb: 1 }}
            InputProps={{
              sx: { fontSize: { xs: "0.85rem", md: "0.65rem" } }
            }}
            InputLabelProps={{
              sx: { fontSize: { xs: "0.75rem", md: "0.6rem" } }
            }}
          />
          <TextField
            label="Email"
            type="email"
            value={editData.mail}
            onChange={(e) => setEditData({ ...editData, mail: e.target.value })}
            fullWidth
            sx={{ mb: 1 }}
            InputProps={{
              sx: { fontSize: { xs: "0.85rem", md: "0.65rem" } }
            }}
            InputLabelProps={{
              sx: { fontSize: { xs: "0.75rem", md: "0.6rem" } }
            }}
          />

          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 1 }}>
            <Tooltip title="Sauvegarder">
              <IconButton 
              onClick={handleSave} 
              color="inherit"
              sx={{ 
                p: 0.5,
                backgroundColor: "transparent !important", // pas de fond 
              }}
              >
                <Save sx={{ color: "#71685e" }} />
              </IconButton>
            </Tooltip>
            
            <Tooltip title="Annuler">
              <IconButton 
              onClick={() => setIsEditing(false)} 
              color="inherit"
              sx={{ 
                p: 0.5,
                backgroundColor: "transparent !important", // pas de fond 
              }}
              >
                <Close sx={{ color: "#f44336" }} />
              </IconButton>
            </Tooltip>
          </Box>
        </>
      ) : (
        <>
          <Typography 
          align="center"
          sx={{ fontSize: { xs: "0.9rem", md: "0.75rem" }, fontWeight: 600 }}
          >
            {contact.nom}</Typography>
          <Typography align="center"
          sx={{ fontSize: { xs: "0.8rem", md: "0.65rem" } }}
          >📞 {contact.telephone || "-"}</Typography>

          <Typography
          align="center"
          sx={{ fontSize: { xs: "0.8rem", md: "0.6rem" } }}
          >✉️ {contact.mail || "-"}</Typography>

          {!isEditing && isAdmin && !sondageVerrouille && (
            <Box sx={{ mt: { xs: 2, md: 3 }, display: "flex", justifyContent: "center", gap: 2 }}>
              <Tooltip title="Modifier">
                <IconButton 
                onClick={() => { 
                  logDev("[FicheContact] clic modifier", contact._id);
                  setIsEditing(true);
                  }}
                color="inherit" // ✅ empêche le style primaire par défaut
                sx={{ 
                  p: 0.5,
                  backgroundColor: "transparent !important", // pas de fond 
                  color: sondageVerrouille ? "#ccc" : "#71685e",
                  cursor: sondageVerrouille ? "not-allowed" : "pointer"
                }} // padding réduit si tu veux
                >
                  <Edit sx={{ color: "#71685e" }} /> {/* ✅ couleur appliquée à l'icône */}
                </IconButton>
              </Tooltip>
              
              <Tooltip title="Supprimer">
                <IconButton 
                  onClick={() => {
                      logDev("[FicheContact] clic supprimer", contact._id);
                      onDelete(contact._id);
                    }}
                    color="inherit"
                    sx={{ 
                      p: 0.5,
                      backgroundColor: "transparent !important",
                      cursor: sondageVerrouille ? "not-allowed" : "pointer",
                      "& .MuiSvgIcon-root": {
                        color: sondageVerrouille ? "#bbb" : "#8B0000",   // 🔥 rouge foncé
                        transition: "0.2s"
                      },
                      "&:hover .MuiSvgIcon-root": {
                        color: sondageVerrouille ? "#bbb" : "#B30000"    // 🔥 rouge vif au hover
                      }
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default FicheContact;
